// extracted by mini-css-extract-plugin
export default {"hideTooltip":"F9-z","fadeIn":"G9-z","delay":"H9-z","recommendedSizeTooltip":"I9-z"};